import { render } from "./AddStudent.vue?vue&type=template&id=00bc29e8&scoped=true"
import script from "./AddStudent.vue?vue&type=script&lang=js"
export * from "./AddStudent.vue?vue&type=script&lang=js"

import "./AddStudent.vue?vue&type=style&index=0&id=00bc29e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bc29e8"]])

export default __exports__